import {ReactElement} from 'react';

import {isNilOrEmpty} from 'ramda-adjunct';

import {escapeRegExp} from 'shared/web';

export const getHighlightedText = (text: string, highlight: string): ReactElement => {
  if (isNilOrEmpty(highlight)) {
    return <>{text}</>;
  }

  const safeHighlight = escapeRegExp(highlight);

  // Using eslint-disable for this specific line because we're properly escaping the input
  // eslint-disable-next-line security/detect-non-literal-regexp
  const parts = text.split(new RegExp(`(${safeHighlight})`, 'gi'));

  return (
    <>
      {parts.map((part) => (
        <span
          key={part}
          style={part.toLowerCase() === highlight.toLowerCase() ? {fontWeight: 'bold'} : {}}
        >
          {part}
        </span>
      ))}
    </>
  );
};
